import { isFunction, isObject } from 'lodash';
import { BaseNode } from './BaseNode';
import { GraphItemModel } from './GraphItem';
import {
  APIWorkspaceAttributes,
  isTag as isTagData,
  isWorkspace as isWorkspaceData,
} from '@ardoq/api-types';
import { entityCssOperations } from '@ardoq/scope-data';

/**
 * Default node implementation for non-component data models
 * Provides basic functionality for workspaces, references, etc.
 * The plan is to replace this with dedicated classes for each data model type.
 * So the sloppiness of types is less relevant here, it's coming from a
 * JavaScript file.
 */
export class DefaultNode extends BaseNode<GraphItemModel> {
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  getShape() {
    return 'predefinedProcess';
  }

  getLabel(): string {
    return this.name();
  }
  /** this is only used by TableGraphBuilder. */
  getValue() {
    if (
      !(
        isObject(this.dataModel) && isFunction((this.dataModel as any).getValue)
      )
    ) {
      return null;
    }

    return /** @type {FieldValue} */ ((this.dataModel as any)).getValue();
  }

  isWorkspace(): this is BaseNode<APIWorkspaceAttributes> {
    return isWorkspaceData(this.dataModel);
  }

  isTag() {
    return (
      isTagData(this.dataModel) ||
      (isObject(this.dataModel) &&
        (this.dataModel as any).urlRoot &&
        (this.dataModel as any).urlRoot.indexOf('/api/tag') !== -1)
    );
  }

  isField() {
    return isObject(this.dataModel) && (this.dataModel as any).field;
  }

  name(): string {
    if (this.isWorkspace()) {
      return this.dataModel.name;
    }

    if (isTagData(this.dataModel)) {
      return this.dataModel.name;
    }

    if (this.isTag()) {
      return (this.dataModel as any).name();
    }

    if (isObject(this.dataModel) && isFunction((this.dataModel as any).name)) {
      return /** @type {NamedGraphItemModel} */ (
        (this.dataModel as any)
      ).name();
    }

    return '';
  }

  getCSSFilterColor() {
    return isObject(this.dataModel) &&
      isFunction((this.dataModel as any).getCSSFilterColor)
      ? (this.dataModel as any).getCSSFilterColor()
      : undefined;
  }

  getCSS(): string {
    if (this.isWorkspace()) {
      return entityCssOperations.getCSSForEntity(this.dataModel);
    } else if (this.isField()) {
      return 'fieldGraphNode';
    } else if (this.isTag()) {
      return 'tagGraphNode';
    }
    return '';
  }

  isIncludedInContextByFilter(): boolean {
    return true;
  }
}
